import { Injectable } from '@angular/core';
import { ContextService, XenaClient } from 'src/app/services'
import { BaseService } from 'src/app/xena-api/controllers/base';
import { IActivityType } from 'src/app/xena-api/dtos';
import { IQueryStringFilter } from 'src/app/xena-api/filters';

@Injectable({
  providedIn: 'root'
})
export class ActivityTypeService extends BaseService<IActivityType, IQueryStringFilter> {
  constructor(xenaClient: XenaClient, context: ContextService) {
    super(xenaClient, context, 'ActivityType');
  }
}
